import FullLayout from 'layout/farm/fullLayout';
import {RouteObject} from 'react-router-dom';
import ChatsContainer from './chat/chatsContainer';
import BuyersPage from './buyers';
import AddAdsPage from './createAd/addAd';
import AccountPage from './account';
import SubProductPage from './subProduct';
import PurchaseContainer from './purchase/mainPurchase';
import PurchaseInfoContainer from './purchase/purchaseInfo';
import PurchaseRegistrationContainer from './purchase/purchaseRegistration';
import PurchaseProductsContainer from './purchase/purchaseProducts';
import PurchaseSubproductsContainer from './purchase/purchaseSubproducts';
import {ShopProvider} from 'context/farmContext';
import SelectCultivation from './createAd/selectCultivation';
import TypeAds from './createAd/typeAds';
import InfoForm from './createAd/form/information';
import QualityForm from './createAd/form/quality';
import AddsContainer from './adds';
import {PurchaseProvider} from 'context/purchaseContext';
import FormOwnerInfo from './createAd/form/owner';
import SimpleDetailPage from './productDetail/simple';
import SaleDetailPage from './productDetail/sale';
import PrepaymentDetailPage from './productDetail/prepayment';
import AuctionDetailPage from './productDetail/auction';
import Guide from './createAd/guid';
import {ProtectedRoute} from 'modules/protectedRoute/farm';
import RolesPage from './account/roles';
import SupportPage from './account/support';
import QuestionsPage from './account/support/questions';
import AboutPage from './account/about';
import ShownAdsPage from './account/shownAds';
import MyAdvertismentContainer from './myAdvertisment/myAdvertisment';
import MyAdvertismentDetailContainer from './myAdvertisment/myAdvertismentDetail';
import PurchaseEditContainer from './purchase/purchaseEdit';
import {CookiesProvider} from 'react-cookie';
import Profile from './profile';
import EditInfoForm from './createAd/editForm/information';
import EditQualityForm from './createAd/editForm/quality';
import EditOwnerForm from './createAd/editForm/owner';
import SelectFarm from './createAd/selectFarm';
import {Suspense, lazy} from 'react';
import Skeleton from 'components/skleton/home';
import HotActionAddsContainer from './hotAuctionAdds';
const Home = lazy(() => import('./home'));
export const FarmRoutes: RouteObject[] = [
  {
    path: 'farm',
    element: (
      <CookiesProvider>
        <ProtectedRoute>
          <PurchaseProvider>
            <ShopProvider>
              <FullLayout />
            </ShopProvider>
          </PurchaseProvider>
        </ProtectedRoute>
      </CookiesProvider>
    ),
    errorElement: <>error page</>,
    children: [
      {
        path: 'home',
        element: (
          <Suspense fallback={<Skeleton />}>
            <Home />
          </Suspense>
        ),
      },
      {
        index: false,
        path: 'chats',
        element: <ChatsContainer />,
      },
      {
        index: false,
        path: 'buyers',
        element: <BuyersPage />,
      },
      {
        index: false,
        path: 'add-ad',
        element: <AddAdsPage />,
      },
      {
        index: false,
        path: 'account',
        element: <AccountPage />,
      },
      {
        index: false,
        path: 'profile/edit',
        element: <Profile />,
      },
      {
        index: false,
        path: 'add-ad/select-cultivation',
        element: <SelectCultivation />,
      },
      {
        index: false,
        path: 'add-ad/sub-product',
        element: <SubProductPage />,
      },
      {
        index: false,
        path: 'add-ad/type-ads',
        element: <TypeAds />,
      },
      {
        index: false,
        path: 'add-ad/purchase',
        element: <PurchaseContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/products/:cateId',
        element: <PurchaseProductsContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/subproducts/:productId',
        element: <PurchaseSubproductsContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/info/:purchaseId',
        element: <PurchaseInfoContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/registration/:purchaseId',
        element: <PurchaseRegistrationContainer />,
      },
      {
        index: false,
        path: 'add-ad/info',
        element: <InfoForm />,
      },
      {
        index: false,
        path: 'add-ad/quality',
        element: <QualityForm />,
      },
      {
        index: false,
        path: 'adds/:guid?',
        element: <AddsContainer />,
      },
      {
        index: false,
        path: 'adds/hot-auctions/:guid?',
        element: <HotActionAddsContainer />,
      },
      {
        index: false,
        path: 'add-ad/owner',
        element: <FormOwnerInfo />,
      },
      {
        index: false,
        path: 'simple/:guid',
        element: <SimpleDetailPage />,
      },
      {
        index: false,
        path: 'sale/:guid',
        element: <SaleDetailPage />,
      },
      {
        index: false,
        path: 'prepayment/:guid',
        element: <PrepaymentDetailPage />,
      },
      {
        index: false,
        path: 'auction/:guid',
        element: <AuctionDetailPage />,
      },
      {
        index: false,
        path: 'account/roles',
        element: <RolesPage />,
      },
      {
        index: false,
        path: 'account/support',
        element: <SupportPage />,
      },
      {
        index: false,
        path: 'account/support/questions',
        element: <QuestionsPage />,
      },
      {
        index: false,
        path: 'account/about',
        element: <AboutPage />,
      },
      {
        index: false,
        path: 'account/shown-ads',
        element: <ShownAdsPage />,
      },
      {
        index: false,
        path: 'my-advertisment',
        element: <MyAdvertismentContainer />,
      },
      {
        index: false,
        path: 'my-advertisment/detail/:guid',
        element: <MyAdvertismentDetailContainer />,
      },
      {
        index: false,
        path: 'add-ad/purchase/edit/:guid',
        element: <PurchaseEditContainer />,
      },
      {
        index: false,
        path: 'guide-to-add-product',
        element: <Guide />,
      },
      {
        index: false,
        path: 'edit/info/:guid',
        element: <EditInfoForm />,
      },
      {
        index: false,
        path: 'edit/quality/:guid',
        element: <EditQualityForm />,
      },
      {
        index: false,
        path: 'edit/owner/:guid',
        element: <EditOwnerForm />,
      },
      {
        index: false,
        path: 'add-ad/list-farms',
        element: <SelectFarm />,
      },
    ],
  },
];
